/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { Alert } from "react-bootstrap-3";
import { FormattedMessage, defineMessages } from "react-intl";

const messages = defineMessages({
  updateSuccesful: {
    id: "app.form.succesfulUpdate",
    description: "Update Successful text",
    defaultMessage: "Update Successful!",
  },
});

function EntityResultMessage({ entityResult }) {
  let message = <FormattedMessage {...messages.updateSuccesful} />;
  return (
    <div>
      <Alert bsStyle="success">
        <strong>{message}</strong>
      </Alert>
    </div>
  );
}

EntityResultMessage.propTypes = {
  entityResult: PropTypes.object,
};

export default EntityResultMessage;
